<div class="container-fluid mt-3 px-4" style="font-size: 0.88rem;">
  
  <!-- Encabezado de Control Máster -->
  <div class="d-flex justify-content-between align-items-center mb-3 border-bottom pb-2">
    <div>
      <h2 class="h5 m-0 fw-bold text-dark">📋 Panel de Aprovisionamiento SaaS (Súper Admin)</h2>
      <span class="small text-muted font-monospace">Global Tenant Provisioning Cockpit / Active Subscriptions</span>
    </div>
    <!-- <button type="button" class="btn btn-success btn-sm px-4 fw-bold shadow-sm text-white" style="border-radius: 6px;" (click)="abrirAltaInquilino()">
      🚀 Dar de Alta Compañía (Taller)
    </button> -->
  <!-- 💡 SOLUCIÓN: Cambiado a un enlace directo con routerLink, igual que CustomerAdd -->
  <a class="btn btn-success btn-sm px-4 fw-bold shadow-sm text-white" routerLink="/admin/saas/add" style="border-radius: 6px;">
    🚀 Dar de Alta Compañía (Taller)
  </a>    
  </div>

  <!-- 🔍 Barra de Búsqueda Reactiva Multi-Columna -->
  <div class="card mb-3 border-0 shadow-sm bg-light">
    <div class="card-body p-2">
      <div class="input-group input-group-sm">
        <span class="input-group-text bg-white border-end-0">🔍</span>
        <input type="text" class="form-control border-start-0 ps-0 text-uppercase" name="buscarCompania"
               [(ngModel)]="filtroTexto" (input)="filtrarCompanias()" placeholder="Filtrar inquilinos por UUID, Razón Social, RFC, Nombre del Dueño o Unidad de Negocio...">
      </div>
    </div>
  </div>

  <!-- 📊 Rejilla Global de Inquilinos -->
  <table class="table table-hover table-striped border shadow-sm align-middle mb-2">
    <thead class="table-dark">
      <tr>
        <th scope="col" style="width: 280px;">UUID CRIPTOGRÁFICO (TENANT)</th>
        <th scope="col" style="width: 100px;" class="text-center">JDE CO</th>
        <th scope="col" style="width: 130px;">BUSINESS UNIT (MCU)</th>
        <th scope="col">RAZÓN SOCIAL / RFC</th>
        <th scope="col">PROPIETARIO / DUEÑO</th>
        <th scope="col" class="text-center" style="width: 110px;">SUSCRIPCIÓN</th>
        <th scope="col" class="text-center" style="width: 100px;">CONTROL</th>
      </tr>
    </thead>
    <tbody>
      <!-- 🚀 ITERACIÓN EN VERDE COMPILANDO LIMPIO CONTRA EL SEGMENTO RECORTADO -->
      <tr *ngFor="let c of companiasPaginadas">
        <td class="font-monospace text-primary fw-bold text-xs" style="letter-spacing: -0.3px;">{{ c.coId }}</td>
        <td class="text-secondary fw-bold text-uppercase">{{ c.ccco }}</td>
        <td><span class="text-secondary fw-semibold text-uppercase">{{ c.mcuBu }}</span></td>
        <td>
          <div class="fw-bold text-dark text-uppercase" style="font-size: 0.84rem;">{{ c.nameAlpha }}</div>
          <span class="small font-monospace text-muted text-uppercase">RFC: {{ c.taxId }}</span>
        </td>
        <td class="text-secondary fw-semibold text-uppercase" style="font-size: 0.82rem;">{{ c.ownerName || 'SIN REGISTRO' }}</td>
        
        <!-- Píldora de Suscripción Dinámica sin advertencias de Ivy NG8107 -->
        <td class="text-center">
          <span class="badge rounded-pill px-3 py-1 font-monospace"
                [ngClass]="c.enabled ? ['bg-success-subtle', 'text-success', 'border', 'border-success'] : ['bg-danger-subtle', 'text-danger', 'border', 'border-danger']">
            {{ c.enabled ? 'ACTIVO' : 'SUSPENDIDO' }}
          </span>
        </td>
        
        <td class="text-center">
          <button type="button" class="btn btn-outline-info btn-sm fw-bold px-3" style="border-radius: 6px;" (click)="abrirEdicionInquilino(c)">
            ✏️ Ajustar
          </button>
        </td>
      </tr>
      
      <!-- REGISTRO VACÍO PREVENTIVO (CATCH DE NO ENCONTRADO) -->
      <tr *ngIf="companiasFiltradas.length === 0">
        <td colspan="7" class="text-center text-muted py-4 font-monospace">
          ⚠️ No conviven compañías registradas en la base de datos bajo ese criterio.
        </td>
      </tr>
    </tbody>
  </table>

  <!-- ========================================================================= -->
  <!-- 🧭 BARRA DE PAGINACIÓN INTERACTIVA CON SALTOS EXTREMOS                    -->
  <!-- ========================================================================= -->
  <div class="d-flex justify-content-between align-items-center mt-2 px-1 mb-4">
    
    <!-- 💡 CORREGIDO CON CONDICIONAL PARA EVITAR CÁLCULOS SOBRE CEROS (RANGO LIMPIO DE INICIALIZACIÓN) -->
    <div class="text-muted font-monospace small">
      <span *ngIf="companiasFiltradas.length > 0">
        Mostrando del <span class="fw-bold text-dark">{{ ((paginaActual - 1) * registrosPorPagina) + 1 }}</span> al 
        <span class="fw-bold text-dark">{{ Math.min(paginaActual * registrosPorPagina, companiasFiltradas.length) }}</span> de 
      </span>
      <span *ngIf="companiasFiltradas.length === 0">Matriz vacía - </span>
      <span class="badge bg-dark font-monospace ms-1">{{ companiasFiltradas.length }}</span> inquilinos activos
    </div>

    <!-- Botonera de Salto Rápido a las Esquinas -->
    <nav aria-label="Navegación SaaS" *ngIf="totalPaginas > 1">
      <ul class="pagination pagination-sm m-0 shadow-sm" style="border-radius: 6px; overflow: hidden; font-size: 0.82rem;">
        
        <!-- Salto al Inicio Absoluto -->
        <li class="page-item" [class.disabled]="paginaActual === 1">
          <button type="button" class="page-link fw-bold text-dark border" (click)="cambiarPagina(1)" style="cursor: pointer;">
            ⏮️ Prime
          </button>
        </li>

        <!-- Retroceder Una Página -->
        <li class="page-item" [class.disabled]="paginaActual === 1">
          <button type="button" class="page-link fw-bold text-dark border" (click)="cambiarPagina(paginaActual - 1)" style="cursor: pointer;">
            ◀️ Ant
          </button>
        </li>

        <!-- Píldora Central Indicadora ERP -->
        <li class="page-item disabled">
          <span class="page-link bg-light text-dark font-monospace border fw-bold px-3">
            PÁGINA {{ paginaActual }} DE {{ totalPaginas }}
          </span>
        </li>

        <!-- Avanzar Una Página -->
        <li class="page-item" [class.disabled]="paginaActual === totalPaginas">
          <button type="button" class="page-link fw-bold text-dark border" (click)="cambiarPagina(paginaActual + 1)" style="cursor: pointer;">
            Sig ▶️
          </button>
        </li>

        <!-- Salto al Final Absoluto -->
        <li class="page-item" [class.disabled]="paginaActual === totalPaginas">
          <button type="button" class="page-link fw-bold text-dark border" (click)="cambiarPagina(totalPaginas)" style="cursor: pointer;">
            Últ ⏭️
          </button>
        </li>

      </ul>
    </nav>
  </div>

  <!-- ========================================================================= 
  // 🚀 INYECTADO: CONTENEDOR FLOTANTE RE-RENDEREADO DE TOASTS CORPORATIVOS
  // ========================================================================= -->
  <div class="toast-container position-fixed top-0 end-0 p-3" style="z-index: 1080; margin-top: 50px;">
    <div *ngFor="let toast of toastService.toasts" 
         class="toast show shadow border-0 mb-2" 
         [ngClass]="'bg-' + toast.type + '-subtle text-dark'"
         role="alert" aria-live="assertive" aria-atomic="true">
      <div class="toast-header border-0 bg-transparent text-dark d-flex justify-content-between align-items-center">
        <strong class="me-auto d-flex align-items-center gap-2">
          <span>{{ toast.type === 'danger' ? '⚠️' : '✅' }}</span>
          {{ toast.title }}
        </strong>
        <button type="button" class="btn-close" (click)="toastService.remove(toast)"></button>
      </div>
      <div class="toast-body pt-0" style="font-size: 0.85rem;">
        {{ toast.text }}
      </div>
    </div>
  </div>

</div>